/*!
 * nc-lieferdatum.js – THE NESTING CLUB · Voraussichtliche Lieferung (ETA)
 * ----------------------------------------------------------------------
 * Eigenes, abhaengigkeitsfreies Asset (kein Fremdskript). Rechnet clientseitig
 * das Lieferfenster aus. Regel (Vorgabe Tanja 13.10.):
 *   - Zeitzone Europe/Vienna (unabhaengig von der Browser-Zeitzone des Kunden).
 *   - Annahmeschluss 14:00 Mo-Fr. Bestellung ab 14:00 oder am WE/Feiertag
 *     zaehlt ab dem naechsten Werktag.
 *   - Lieferung +1 bis +3 Werktage ab Annahmetag.
 *   - Wochenenden + gesetzliche Feiertage AT und DE (bundesweit) werden
 *     uebersprungen (Liste 2026-2027 unten, UNION beider Laender).
 *
 * Das Modul ist zugleich im Browser (DOM-Fuellung) und in Node (Unit-Test)
 * nutzbar: die reine Rechenlogik haengt NICHT am DOM.
 */
(function (global) {
  'use strict';

  // UNION der bundeseinheitlichen gesetzlichen Feiertage AT + DE (2026-2027).
  // Deterministische Kalenderfakten (Ostern 2026 = 05.04., Ostern 2027 = 28.03.).
  var HOLIDAYS = {
    // ---- 2026 ----
    '2026-01-01': 1, // Neujahr (AT+DE)
    '2026-01-06': 1, // Heilige Drei Koenige (AT)
    '2026-04-03': 1, // Karfreitag (DE)
    '2026-04-06': 1, // Ostermontag (AT+DE)
    '2026-05-01': 1, // Staatsfeiertag / Tag der Arbeit (AT+DE)
    '2026-05-14': 1, // Christi Himmelfahrt (AT+DE)
    '2026-05-25': 1, // Pfingstmontag (AT+DE)
    '2026-06-04': 1, // Fronleichnam (AT)
    '2026-08-15': 1, // Mariae Himmelfahrt (AT)
    '2026-10-03': 1, // Tag der Deutschen Einheit (DE)
    '2026-10-26': 1, // Nationalfeiertag (AT)
    '2026-11-01': 1, // Allerheiligen (AT)
    '2026-12-08': 1, // Mariae Empfaengnis (AT)
    '2026-12-25': 1, // 1. Weihnachtstag (AT+DE)
    '2026-12-26': 1, // 2. Weihnachtstag (AT+DE)
    // ---- 2027 ----
    '2027-01-01': 1, // Neujahr (AT+DE)
    '2027-01-06': 1, // Heilige Drei Koenige (AT)
    '2027-03-26': 1, // Karfreitag (DE)
    '2027-03-29': 1, // Ostermontag (AT+DE)
    '2027-05-01': 1, // Staatsfeiertag / Tag der Arbeit (AT+DE)
    '2027-05-06': 1, // Christi Himmelfahrt (AT+DE)
    '2027-05-17': 1, // Pfingstmontag (AT+DE)
    '2027-05-27': 1, // Fronleichnam (AT)
    '2027-08-15': 1, // Mariae Himmelfahrt (AT) – fällt 2027 auf Sonntag
    '2027-10-03': 1, // Tag der Deutschen Einheit (DE) – fällt 2027 auf Sonntag
    '2027-10-26': 1, // Nationalfeiertag (AT)
    '2027-11-01': 1, // Allerheiligen (AT)
    '2027-12-08': 1, // Mariae Empfaengnis (AT)
    '2027-12-25': 1, // 1. Weihnachtstag (AT+DE)
    '2027-12-26': 1  // 2. Weihnachtstag (AT+DE)
  };

  var WD = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  // Monatskuerzel oesterreichisch (Jaenner).
  var MON = ['Jän.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  // Kalender-Cursor = UTC-Mitternacht des jeweiligen Zivil-Datums (DST-sicher).
  function key(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function isWorking(d) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;      // So/Sa
    return !HOLIDAYS[key(d)];                     // Feiertag?
  }
  function addDays(d, n) {
    var x = new Date(d.getTime());
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  }
  function addWorking(d, n) {                     // +n Werktage
    var x = d, c = 0;
    while (c < n) { x = addDays(x, 1); if (isWorking(x)) c++; }
    return x;
  }
  function nextWorkingFrom(d) {                   // erster Werktag >= d
    var x = d;
    while (!isWorking(x)) { x = addDays(x, 1); }
    return x;
  }

  // Europe/Vienna-Wanduhr aus einem absoluten Zeitpunkt (unabhaengig von Browser-TZ).
  function viennaParts(now) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
    });
    var o = {};
    fmt.formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
    // 'hour' kann in en-GB um Mitternacht '24' liefern -> normalisieren.
    var h = parseInt(o.hour, 10); if (h === 24) h = 0;
    return { y: +o.year, m: +o.month, d: +o.day, h: h, min: +o.minute };
  }

  // Kern: liefert { earliest, latest } als UTC-Kalender-Dates.
  function computeRange(now) {
    var v = viennaParts(now);
    var civil = new Date(Date.UTC(v.y, v.m - 1, v.d));
    var passed = v.h >= 14;                        // Annahmeschluss 14:00
    var annahme;
    if (isWorking(civil) && !passed) {
      annahme = civil;                             // heute noch Annahme
    } else {
      annahme = nextWorkingFrom(addDays(civil, 1)); // ab naechstem Werktag
    }
    return { earliest: addWorking(annahme, 1), latest: addWorking(annahme, 3) };
  }

  function fmtDay(d) { return WD[d.getUTCDay()] + ', ' + d.getUTCDate() + '. ' + MON[d.getUTCMonth()]; }

  function label(now) {
    var r = computeRange(now);
    if (key(r.earliest) === key(r.latest)) return fmtDay(r.earliest);
    return fmtDay(r.earliest) + ' – ' + fmtDay(r.latest);
  }

  var api = { computeRange: computeRange, label: label, fmtDay: fmtDay, isWorking: isWorking, HOLIDAYS: HOLIDAYS };

  // --- Browser: ETA-Elemente fuellen ---
  if (typeof document !== 'undefined') {
    var init = function () {
      var els = document.querySelectorAll('[data-nc-eta]');
      if (!els.length) return;
      var txt;
      try { txt = label(new Date()); } catch (e) { return; } // bei Intl-Fehler: Fallback-Markup bleibt
      for (var i = 0; i < els.length; i++) {
        var t = els[i].querySelector('[data-nc-eta-date]') || els[i];
        t.textContent = txt;
        els[i].removeAttribute('hidden');
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  }

  global.ncLieferdatum = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : this);
